import { DEFAULT_BRAND } from '@thesavingsgroup/constants';
import has from 'lodash/has';

import { osanoScriptUrlByBrand } from '../constants/osano';

export const toOsanoScriptUrl = (brand: string): string =>
  has(osanoScriptUrlByBrand, brand)
    ? osanoScriptUrlByBrand[brand]
    : osanoScriptUrlByBrand[DEFAULT_BRAND];
